import {Text, Tooltip} from '@chakra-ui/react'
import React from 'react'
import {FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import {useOrderSummary} from './order-summary-provider'
import {InfoIconFilled} from '../icons'
import {useCurrentCustomer} from '../../hooks/use-current-customer'

const OrderSummaryVat = () => {
    const basket = useOrderSummary()
    const {isCustomNetPriceEnabled} = useCurrentCustomer().data
    const {formatNumber} = useIntl()

    return (
        <>
            {!isCustomNetPriceEnabled && (
                <Text data-testid="taxtotal_text">
                    <FormattedMessage id="global.taxes" defaultMessage="Taxes" />
                </Text>
            )}
            {isCustomNetPriceEnabled && (
                <Text data-testid="taxtotal_text">
                    <FormattedMessage id="global.taxes_vat" defaultMessage="VAT" />
                    {/*this works only if all products sold on STOKKE has the same taxrate*/}
                    {/*its alligned that this is the case for D2B MVP*/}
                    <Tooltip
                        hasArrow
                        placement="top"
                        label={formatNumber(basket.productItems?.[0].taxRate, {
                            style: 'percent'
                        })}
                    >
                        <InfoIconFilled variant="tooltip" />
                    </Tooltip>
                </Text>
            )}
            <Text data-testid="taxtotal_value">
                <FormattedNumber
                    value={basket.taxTotal}
                    style="currency"
                    currency={basket.currency}
                />
            </Text>
        </>
    )
}

export default OrderSummaryVat
